import { Dispatch } from 'redux';
import { authActions } from '../auth.reducer';
import { getLoggedInUser } from './getLoggedInUser';

export const refreshUser = () => async (dispatch: Dispatch) => {
  const user = await getLoggedInUser();
  console.log('User session was refreshed with result', user);

  dispatch(authActions.setUser(user));
};
